var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-advanced-data-table',{attrs:{"items":_vm.steps,"headers":_vm.headers,"hide-actions":""},scopedSlots:_vm._u([{key:"item",fn:function(props){return [_c('remediation-instruction-executions-expand-panel-row',{attrs:{"step":props.item}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }